export function searchClients ({ state, commit }, clientKEY) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/usernames', { params: { clientKEY } })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getUsernamesData ({ state, commit }, userids) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/usernames', { userids })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getAgentsData ({ state, commit }, accountkeys) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/agents', { accountkeys })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export async function initSW ({ dispatch }) {
    return new Promise(async function (resolve, reject) {
        if (!'serviceWorker' in navigator) {
            reject()
        }

        if (!'PushManager' in window) {
            reject()
        }

        await dispatch('registerSW')
            .then(async () => {
                console.log('serviceWorker installed!')
                await dispatch('initPush').then(async (permissionResult) => {
                    console.log('initPush result', permissionResult)
                    if (permissionResult !== 'granted') {
                        console.log('Notification not granted.')
                        reject()
                    } else {
                        await dispatch('subscribeToWebPush').then((resp) => {
                            if(resp === true) {
                                resolve(true)
                            } else {
                                alert('subscribeToWebPush response error')
                            }
                        })
                    }
                }).catch((error) => {
                    console.log('initPush reject1', error)
                    alert('initPush reject1')
                    reject()
                })
            })
            .catch((err) => {
                console.log('initPush reject2', err)
                alert('initPush reject2')
                reject()
            })
    })
}

export async function registerSW () {
    return new Promise(async function (resolve, reject) {
        await navigator.serviceWorker.register('/service-worker.js?v=1.00').then(() => {
            resolve()
        }).catch(() => {
            alert('registerSW error')
            reject()
        })
    })
}

export async function initPush({ state }) {
    return new Promise(async function (resolve, reject) {
        if (!navigator.serviceWorker.ready) {
            reject()
        }

        Promise.resolve(Notification.requestPermission()).then(function(permission) {
            resolve(permission)
        }).catch(() => { reject() })
    })
}

export async function subscribeToWebPush () {
    return new Promise(async function (resolve, reject) {
        await navigator.serviceWorker.ready
            .then((registration) => {
                const subscribeOptions = {
                    userVisibleOnly: true,
                    applicationServerKey: urlBase64ToUint8Array(
                        process.env.MIX_VAPID_PUBLIC_KEY ?? ''
                    )
                }

                return registration.pushManager.subscribe(subscribeOptions)
            })
            .then((pushSubscription) => {
                if (!pushSubscription) {
                    console.log('Error occured while subscribing')
                    reject()
                }
                resolve(true)
                /**subscribePush(pushSubscription).then((response) => {
                    resolve(true)
                })
                .catch(() => {
                    alert('subscribeToWebPush subscribePush error')
                    reject()
                })**/
            })
            .catch((err) => {
                alert('subscribeToWebPush error: ' + (err.message || ''))
                reject()
            })
    })
}

export function subscribePush(pushSubscription) {
  return new Promise((resolve, reject) => {
    axios.post('/api/v1/subscribePush', pushSubscription)
    .then((response) => {
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    })
  })
}

export function unsubscribePush(pushSubscription) {
  return new Promise((resolve, reject) => {
    axios.post('/api/v1/unsubscribePush', pushSubscription)
    .then((response) => {
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    })
  })
}